export enum StartupModalPriorities {
  forceInstallTwa = 6,
  clockMismatch = 5,
  profileCompletion = 4,
  changeLog = 4,
  grantContactPermission = 3,
  grantNotificationPermission = 3,
  updateTwaAvailable = 2,
  nonTwaNotificationPermission = 2,
  outOfDateBrowser = 1,
  outOfDateOs = 1,
}
